<template>
  <div class="page">
    <el-container>
      <el-header class="header">
        <el-row :gutter="24" type="flex">
          <el-col :span="5">
            <div class="assist">
              <el-image
              fit="contain"
              :src="src"
              style="width: 10rem; margin-top: 0.5rem;"
            ></el-image>
            <div style="margin: 0 18px;width: 2px;height: 21px;background: #282B31;display: inline-block;margin-left:-4px"></div>
            <div style="width:100px;font-size: 18px;font-weight: 400;color: #282b31;display: inline-block;">帮助中心</div>
            </div>
          </el-col>
          <el-col :span="10">
            <div>
              <el-menu
                :default-active="topMenusAct"
                class="top-menu"
                mode="horizontal"
                @select="handleTopMenuSelect"
                :router="false"
              >
                <el-menu-item
                  :index="res.url"
                  v-for="res in topMenus"
                  :key="res.id"
                >
                  <!-- <a style="text-decoration:none;" :href="res.url" target="_blank"> -->
                  {{ res.name }}
                  <!-- </a> -->
                </el-menu-item>
              </el-menu>
            </div>
          </el-col>

          <el-col :span="9" class="header-el-row">
            <el-row :gutter="22">
              <!-- @input="findKeyWord" -->
              <el-col :span="22" class="search">
                <el-autocomplete
                  placeholder="请输入关键字"
                  :fetch-suggestions="querySearch"
                  value-key="title"
                  @select="handleSelect"
                  v-model="input4"
                  size="large"
                  highlight-first-item
                  style="font-size: 20px; margin-top: 0.333rem; width: 100%"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-autocomplete>
              </el-col>
              <!-- <el-col :span="8"> <el-button type="primary" @click="findKeyWord">搜索</el-button></el-col> -->
            </el-row>
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-aside width="14rem" class="left">
          <el-menu
            :default-active="$store.state.thisKey"
            :unique-opened="true"
            :router="false"
            @open="open"
            @close="handleClose"
            :default-openeds="opends"
            background-color="#f7f8f9"
            text-color="#000000"
            active-text-color="#0474f4"
            v-for="(item, index, key) in menus1"
            :key="key"
            @click.native="showIcon(item)"
          >
            <i  :class='item.show == false?"el-icon-caret-right show_icon":"el-icon-caret-bottom show_icon"'></i>
            <el-submenu :index="item.text">
              <template slot="title">{{ item.text }}</template>
              <el-menu-item
                @click="ckChilden"
                :index="v.text"
                v-for="v in item.children"
                :key="v.id"
                >
                <i class="el-icon-s-order"></i>
                {{ v.text }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </el-aside>

        <el-main>
          <!-- 面包屑 -->
          <div class="main-heder">
            <!-- <el-page-header @back="goBack" :content="$store.state.title"></el-page-header> -->
            <div class="crumbs">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item
                  :to="breadBank($store.getters.getLinks, linum)"
                  v-for="(li, linum) in $store.getters.getLinks"
                  :key="linum"
                  >{{ li }}</el-breadcrumb-item
                >
              </el-breadcrumb>
            </div>
          </div>
          <div class="main-view">
            <router-view v-if="$route.matched.length > 1 && $route.matched[0].name == 'Doc'"></router-view>
            <empty v-else/>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import backImg from "@/assets/logo-help.png";
// import Home from "../components/Result.vue";
import { ajax } from "@/network/request";
import empty from "@/views/empty";

export default {
  name: "App",
  components: { empty },
  data() {
    return {
      judgment:true,
      show:false,
      topMenusAct: "",
      name: {
        type: "Number",
        default: "",
      },
      src: backImg,
      clientHeight: "",
      input4: "",
      menus: [],
      menus1:[],
      thisKey: "",
      opends: [],
      topMenus: [
        {
          id: 1001,
          name: "公司动态",
          url: "http://www.geecity.com/News",
        },
        {
          id: 1002,
          name: "产品介绍",
          url: "http://www.geecity.com/Products",
        },
        {
          id: 1003,
          name: "物业课堂",
          url: "http://www.geecity.com/Course",
        },
        {
          id: 1004,
          name: "客户案例",
          url: "http://www.geecity.com/Case",
        },
        {
          id: 1005,
          name: "四驱服务",
          url: "http://www.geecity.com/Service",
        },
        {
          id: 1006,
          name: "关于我们",
          url: "http://www.geecity.com/About-us",
        },
      ],
    };
  },
  onLoad(options) {
   console.log(options);
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`;
    //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
    console.log('进来咯',this.$route.matched);
  },
  created() {
    console.log(this.$route.params.name);
    // this.thisKey = this.$store.getters.getthisKey();

    // this.name = this.$route.params.name;
    this.sign = false;

    ajax({
      url: "/helper/tree",
      method: "get",
      baseURL: "/hehe",
      // data: {

      // }
    }).then((res) => {
      console.log(res);
      this.menus = res.data.children;
      this.menus.map((item)=>{
        this.menus1.push(Object.assign({...item},{show:false}))
      })
    });
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function () {
      this.changeFixed(this.clientHeight);
    },
  },
  methods: {
    /**
     * 模糊查询
     */
    querySearch(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      ajax({
        url: "/helper/getList",
        method: "POST",
        baseURL: "/hehe",
        data: {
          likeName: queryString,
        },
      }).then((res) => {
        console.log(res);

        // 调用 callback 返回建议列表的数据
        cb(res.data);
      });
    },
    handleTopMenuSelect(item) {
      console.log(item);
      window.open(item);
    },
    handleSelect(item) {
      console.log(item);

      // this.$store.commit("setLinks", [
      //   item.parentMenuName,
      //   item.menuName,
      //   item.id,
      // ]);
      // this.$store.commit("setThisKey", item.menuName);
      this.$router.push({
        name: "mid",
        params: {
          id: item.id,
          parentMenuName: item.parentMenuName,
          menuName: item.menuName,
        },
      });
    },

    /**
     * 面包屑返回
     */
    breadBank(val, num) {
      if (num == 0 || num == val.length - 1) {
        return "";
      }
      let addr = "";
      for (let i in val) {
        if (i != val.length - 1) {
          addr += val[i] + "/";
        }
      }
      return "/doc/" + addr;
    },
    /**
     * 点击子菜单
     */
    ckChilden(val) {
      this.judgment = false,

      this.sign = false;
      // console.log(val)
      // console.log(val.indexPath)
      this.$store.commit("setLinks", val.indexPath);
      this.$router.push({
        name: "textList",
        params: {
          parentMenuName: val.indexPath[0],
          menuName: val.indexPath[1],
        },
      })
    },
    showIcon(item){
      this.menus1.map((item1)=>{
        if (item.show == item1.show) {
          item.show == item1.show
        } else{
          item1.show = false
        }
      })
      if (this.judgment) {
        if (item.show == false) {
          item.show = true
        } else{
          item.show =false
        } 
      } else{
        this.judgment = true
      }
      //  localStorage.setItem('menus', JSON.stringify(this.menus1))
    },
    open(index,item) {
      console.log(item);
      // console.log(this.thisKey)
      this.opends.length = 0;
      this.opends.push(index);
      // console.log(this.opends)
    },
    handleClose(){
      console.log(999);
    },
    open2(){
      console.log(222);
    },
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      // console.log(this.$refs.homePage.$el.style.height);
      // this.$refs.homePage.$el.style.height = clientHeight - 20 + "px";
    },
  },
  // beforeRouteUpdate(to, from, next) {
  //   // console.log(to);
  //   this.path = to.params.path;
  //   this.name = to.params.name;
  //   next();
  // },
};
</script>

<style  lang="scss" scoped >
.menu{
  position: relative;
}
.show_icon{
  position: absolute;
  top: 13px;
  z-index: 999;
}
// .el-submenu__icon-arrow{
//   display: none !important;
// }
.page {
  // height: 100vh;
  .header {
    border-bottom: #eeeeee 1px solid;
    box-shadow: 0px 15px 15px -15px #eeeeee;
    height: 60.5px !important;
  }

  .top-menu > a {
    text-decoration: none;
  }
  .main {
    // height: 100rem;
  }
  .left {
    // background-color: pink;
    // margin-top: 1rem;
    // height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    .el-menu{
      padding-left: 1rem;
    }
    .el-menu-item{
      height: 40px !important;
      line-height: 40px !important;
    }
    .el-menu-item:hover {
      outline: 0 !important;
      color: #0474f4 !important;
      background: #deedff !important;
    }
    .el-menu-item.is-active {
      color: #0474f4 !important;
      background: #deedff !important;
    }
    /deep/ .el-breadcrumb__item .el-breadcrumb__inner {
      font-size: 18px;
      //  background-color: rgba(51,112,255,.1);
    }
  }

  .left::-webkit-scrollbar {
    display: none;
  }
}

.el-header {
  position: relative;
  width: 100%;
  height: 60px;
}
.el-aside {
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
}
.el-main {
  padding: 0 !important;
  .main-heder {
    border-bottom: 1px solid #e6e6e6;
    width: 100%;
    padding: 0 !important;
    padding-left: 30px !important;
    position: absolute;
    left: 14rem;
    //   width: 50%;
    //   height: 16px;
    background-color: #fff;
    padding-left: 1rem;
    padding-top: 1rem;
    .el-breadcrumb span{
      line-height: 40px;
      height: 40px;
    }
  }
  .main-view {
    position: absolute;
    left: 15rem;
    right: 0;
    top: 86px;
    bottom: 0;
    overflow-y: scroll;
    margin-top: 1rem;
  }
}

.el-aside {
  text-align: left;
  // margin-left: 1rem;

  /* color: #333; */
  /* background-color:red; */
}

/*
    找到html标签、body标签，和挂载的标签
    都给他们统一设置样式
*/
// html,
// body,
// .el-container {
//   /*设置内部填充为0，几个布局元素之间没有间距*/
//   padding: 0px;
//   /*外部间距也是如此设置*/
//   margin: 0px;
//   /*统一设置高度为100%*/
//   height: 100%;
// }

.doc-main {
  /* border-left-style: solid; */
  border-width: 0.5px;
  //   margin-left: 10px;
  /* border-color: #eee; */
  /* overflow-x: hidden; */
  /* background-color: #eee; */
  text-align: center;
  // width: 100%;
  margin-top: 1rem;
}

.aside-menu {
  border-right: rgba(238, 238, 238, 0.856) 1px solid;
  width: 20rem !important;
}
.assist{
  display: flex;
  align-items: center;
  justify-items: center;
  height: 60px;
}
.el-row--flex{
  align-items: center !important;
  justify-items: center !important;
}
.el-autocomplete{
  margin-top: 0 !important;
}
.crumbs{
  height: 40px;
  width: 100%;
}
</style>